import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    margin: '24px 40px',
    padding: '20px'
  },
  headerWrapper: {
    //display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '40px 40px 24px',
    height: '100%'
  },
  filterWrapper: {
    padding: '10px',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px'
  },
  formContainer: {
    margin: '0 40px',
    padding: '20px 40px',
  },
  buttonContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start'
  },
  button: {
    maxWidth: 220,
  },
  primaryButton: {
    color: 'white',
    marginRight: '20px'
  },
  userHeaderWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '20px 20px',
  },
  mt4: {
    marginTop: '60px',
  },
  cardTitle: {
    marginBottom: '15px',
    fontSize: '20px',
    color: '#545456'
  },
  submitButton: {
    maxWidth: '220px',
    color: 'white',
    float: 'right',
    margin: '5px'
  },
  cancelButton: {
    maxWidth: '220px',
    float: 'right',
    margin: '5px'
  },
  filterIcon: {
    backgroundColor: '#70707033',
    color: '#9F9E9E',
    padding: 5,
    borderRadius: 5
  },
  cogIcon: {
    position: 'absolute',
    right: '70px'
  },
  formIcon: {
    verticalAlign: 'middle',
    margin: '8px 0'
  },
  buttons: {
    width: 'auto',
    minWidth: '150px',
    minHeight: '36px',
    margin: '10px 0'
  },
  mr4: {
    marginRight: '10px',
  },
  mapWrapper: {
    minHeight: '30rem',
    width: '100%',
  },
  mapMarker: {
    border: '1px solid #01B4DE',
    height: '10px',
    width: '10px',
    background: '#01B4DE',
    borderRadius: '50%'
  },
  clearFilter: {
    color: '#6B7073',
    background: '#70707033',
    '&:hover': {
      background: '#70707033'
    }
  },
  headingWrapper: {
    '@media (max-width: 450px)': {
      flexWrap: 'nowrap',
    }
  },
  upperCaseHeadings: {
    '& span': {
      fontSize: '14px',
      textTransform: 'uppercase !important'
    },
  },
  betweenFilterText: {
    color: '#6F6F6F'
  },
  valueInput: {
    display: 'flex',
    flexGrow: 1
  },
  tableRightAlign: {
    textAlign: 'right',

    '& p': {
      marginRight: '50px'
    }
  },
  tableCenterAlign: {
    textAlign: 'center',
  },
  batteryCapacity: {
    width: '230px',
    minWidth: '230px',
    textAlign: 'center'
  },
  committedPower: {
    width: '225px',
    minWidth: '225px',
    textAlign: 'center'
  },
  batteryPower: {
    width: '205px',
    minWidth: '205px',
    textAlign: 'center'
  },
  input: {
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  }
}))

export { useStyles }